import { LoginComponent } from './../login/login.component';
import { RegistrarseComponent } from './../registrarse/registrarse.component';
import { MatDialog } from '@angular/material/dialog';
import { HardcodedAutheticationService } from './../service/hardcoded-authetication.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CalendarioComponent } from '../calendario/calendario.component';
import { AuthService } from '../service/seguridad/auth.service';
import { Evento } from '../eventos/evento.model';
import { EventoDataService } from '../service/data/evento-data.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  usuario: string;
  eventos: Evento[] = [];
  constructor(
    private router: Router,
    public autenticacion: HardcodedAutheticationService,
    public dialog: MatDialog,
    private service: EventoDataService
  ) {}

  ngOnInit(): void {
    this.service.getEventoId("AT2024-62").subscribe((response) => {
      this.handleSuccesfullGet(response);
    });
  }
  handleSuccesfullGet(response) {
    this.eventos=[]
    this.eventos.push(response)
  }
  cargarUsuario() {
    if (window.innerWidth <= 960) {
      let menu = document.getElementById('barra');
      menu.style.height = '70px';
      menu.classList.toggle('expandir');
      let nav1 = document.getElementById('links1');
      let nav3 = document.getElementById('links3');
      nav1.classList.toggle('mostrar');
      nav3.classList.toggle('mostrar');
    }
    this.usuario = this.autenticacion.getUsuario();
    this.router.navigate(['/usuarios/usuario', this.usuario]);
  }
  cargarAdmin() {
    if (window.innerWidth <= 960) {
      let menu = document.getElementById('barra');
      menu.style.height = '70px';
      menu.classList.toggle('expandir');
      let nav1 = document.getElementById('links1');
      let nav3 = document.getElementById('links3');
      nav1.classList.toggle('mostrar');
      nav3.classList.toggle('mostrar');
    }
    this.usuario = this.autenticacion.getAdmin();
    this.router.navigate(['/administradores/admin', this.usuario]);
  }
  cargarOrganizador() {
    if (window.innerWidth <= 960) {
      let menu = document.getElementById('barra');
      menu.style.height = '70px';
      menu.classList.toggle('expandir');
      let nav1 = document.getElementById('links1');
      let nav3 = document.getElementById('links3');
      nav1.classList.toggle('mostrar');
      nav3.classList.toggle('mostrar');
    }
    this.usuario = this.autenticacion.getOrganizador();
    this.router.navigate(['organizadores/organizador', this.usuario]);
  }
  cargarMinisterio() {
    if (window.innerWidth <= 960) {
      let menu = document.getElementById('barra');
      menu.style.height = '70px';
      menu.classList.toggle('expandir');
      let nav1 = document.getElementById('links1');
      let nav3 = document.getElementById('links3');
      nav1.classList.toggle('mostrar');
      nav3.classList.toggle('mostrar');
    }
    this.usuario = this.autenticacion.getMinisterio();
    this.router.navigate(['perfilMinisterio', this.usuario]);
  }
  cargarPuntoFisico() {
    if (window.innerWidth <= 960) {
      let menu = document.getElementById('barra');
      menu.style.height = '70px';
      menu.classList.toggle('expandir');
      let nav1 = document.getElementById('links1');
      let nav3 = document.getElementById('links3');
      nav1.classList.toggle('mostrar');
      nav3.classList.toggle('mostrar');
    }
    this.usuario = this.autenticacion.getPuntoFisico();
    this.router.navigate(['puntoFisico', this.usuario]);
  }
  cargarPromotor() {
    if (window.innerWidth <= 960) {
      let menu = document.getElementById('barra');
      menu.style.height = '70px';
      menu.classList.toggle('expandir');
      let nav1 = document.getElementById('links1');
      let nav3 = document.getElementById('links3');
      nav1.classList.toggle('mostrar');
      nav3.classList.toggle('mostrar');
    }
    this.usuario = this.autenticacion.getPromotor();
    this.router.navigate(['promotor', this.usuario]);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(RegistrarseComponent, {
      width: '600px',
      height: '90%',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  openDialog2(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  openDialog7() {
    const dialogRef = this.dialog.open(CalendarioComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
  tooglemenu() {
    let menu = document.getElementById('barra');

    if (menu.style.height != window.innerHeight.toString() + 'px') {
      menu.style.height = window.innerHeight.toString() + 'px';
    } else {
      menu.style.height = '70px';
    }
    menu.classList.toggle('expandir');
    console.log(menu.style.height);
    let nav1 = document.getElementById('links1');
    let nav3 = document.getElementById('links3');
    nav1.classList.toggle('mostrar');
    nav3.classList.toggle('mostrar');
  }
  cambiar(id) {
    if (window.innerWidth <= 960) {
      let menu = document.getElementById('barra');
      menu.style.height = '70px';
      menu.classList.toggle('expandir');
      let nav1 = document.getElementById('links1');
      let nav3 = document.getElementById('links3');
      nav1.classList.toggle('mostrar');
      nav3.classList.toggle('mostrar');
    }
    this.router.navigate(['/eventos/evento/' + id]);
  }
  home() {
    if (window.innerWidth <= 960) {
      let menu = document.getElementById('barra');
      menu.style.height = '70px';
      menu.classList.toggle('expandir');
      let nav1 = document.getElementById('links1');
      let nav3 = document.getElementById('links3');
      nav1.classList.toggle('mostrar');
      nav3.classList.toggle('mostrar');
    }
    this.router.navigate(['/home']);
  }
}
